import {createApp} from 'vue';

export async function initAdminActivityMonitor() {
  const el = document.querySelector('#admin-activity-monitor');
  if (!el) return;

  const {default: AdminActivityMonitor} = await import('../components/AdminActivityMonitor.vue');
  try {
    const View = createApp(AdminActivityMonitor);
    View.mount(el);
  } catch (err) {
    console.error('AdminActivityMonitor failed to load', err);
    el.textContent = 'Failed to load activity monitor';
  }
}
